"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "main-settings-container" };
const _hoisted_2 = {
    key: 0,
    class: "settings-card-container"
};
const _hoisted_3 = { class: "settings-item" };
const _hoisted_4 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_5 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_6 = { class: "settings-input oplus-form-switch" };
const _hoisted_7 = ["href"];
const InfoIcon_vue_1 = __importDefault(require("../icons/InfoIcon.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'SettingsOthersContent',
    props: {
        isDefaultSettingsPage: {
            type: Boolean,
            default: false,
        },
        userId: {
            type: String,
            required: true,
        }
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (__props.isDefaultSettingsPage)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_2, [
                        _cache[2] || (_cache[2] = (0, vue_2.createElementVNode)("div", { class: "settings-title-wrapper" }, [
                            (0, vue_2.createElementVNode)("span", { class: "page-title-text" }, "退会")
                        ], -1 /* CACHED */)),
                        (0, vue_2.createCommentVNode)(" apiRemoveExisting "),
                        (0, vue_2.createElementVNode)("div", _hoisted_3, [
                            (0, vue_2.createElementVNode)("div", _hoisted_4, [
                                _cache[1] || (_cache[1] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "退会手続き", -1 /* CACHED */)),
                                (0, vue_2.createElementVNode)("div", _hoisted_5, [
                                    (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                    _cache[0] || (_cache[0] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
                                        (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "シフトや従業員情報を含むすべてのデータが削除されます。")
                                    ], -1 /* CACHED */))
                                ])
                            ]),
                            (0, vue_2.createElementVNode)("label", _hoisted_6, [
                                (0, vue_2.createElementVNode)("a", {
                                    href: `/dashboard/${__props.userId}/deactivate`,
                                    class: "oplus-btn oplus-btn-error-alt"
                                }, "退会", 8 /* PROPS */, _hoisted_7)
                            ])
                        ])
                    ]))
                    : (0, vue_2.createCommentVNode)("v-if", true)
            ]));
        };
    }
});
